export default {
    // MASTER
    GET_MASTER_STATIC_VALUES: {
        url: "/api/v1/master",
        method: "get",
    },

    // MASTER - LOCATION
    ADD_MASTER_LOCATION: {
        url: "/api/v1/master/location",
        method: "post",
    },
    GET_MASTER_LOCATIONS: {
        url: "/api/v1/master/location",
        method: "get",
    },
    GET_MASTER_LOCATION_BY_NAME: {
        url: "/api/v1/master/location/name/{location_name}",
        method: "get",
    },
    GET_MASTER_LOCATION_BY_ID: {
        url: "/api/v1/master/location/unique/{location_id}",
        method: "get",
    },
    UPDATE_MASTER_LOCATION: {
        url: "/api/v1/master/location/{location_id}",
        method: "put",
    },
    DELETE_MASTER_LOCATION: {
        url: "/api/v1/master/location/{location_id}",
        method: "delete",
    },

    // MASTER - ROLES
    // ADD_MASTER_ROLE: {
    //     url: "/api/v1/master-role",
    //     method: "post",
    // },
    GET_MASTER_ROLES: {
        url: "/api/v1/master-role",
        method: "get",
    },
    // DELETE_MASTER_ROLE: {
    //     url: "/api/v1/master-role/{role}",
    //     method: "delete",
    // },

    // MASTER DESTIGNATION
    ADD_MASTER_DESIGNATION: {
        url: "/api/v1/master-designation",
        method: "post",
    },
    GET_MASTER_DESIGNATIONS: {
        url: "/api/v1/master-designation",
        method: "get",
    },
    DELETE_MASTER_DESIGNATION: {
        url: "/api/v1/master-designation/{designation}",
        method: "delete",
    },

    // MASTER DEPARTMENT
    ADD_MASTER_DEPARTMENT: {
        url: "/api/v1/master-department",
        method: "post",
    },
    GET_MASTER_DEPARTMENTS: {
        url: "/api/v1/master-department",
        method: "get",
    },
    DELETE_MASTER_DEPARTMENT: {
        url: "/api/v1/master-department/{department}",
        method: "delete",
    },

    // BANK-NAMES
    ADD_BANK_NAME: {
        url: "/api/v1/master-bank",
        method: "post",
    },
    GET_BANK_NAMES: {
        url: "/api/v1/master-bank",
        method: "get",
    },
    GET_BANK_BY_ID: {
        url: "/api/v1/master-bank/{bankId}",
        method: "get",
    },
    UPDATE_BANK_NAME: {
        url: "/api/v1/master-bank/{bankId}",
        method: "put",
    },
    DELETE_BANK_NAME: {
        url: "/api/v1/master-bank/{bankId}",
        method: "delete",
    },

    // MASTER - BANK WISE OFFER
    ADD_BANK_OFFER: {
        url: "/api/v1/master-bank-offer",
        method: "post",
    },
    GET_BANK_OFFERS: {
        url: "/api/v1/master-bank-offer",
        method: "get",
    },
    GET_BANK_OFFER_BY_ID: {
        url: "/api/v1/master-bank-offer/{bankId}",
        method: "get",
    },
    UPDATE_BANK_OFFER: {
        url: "/api/v1/master-bank-offer/{bankId}",
        method: "put",
    },
    DELETE_BANK_OFFER: {
        url: "/api/v1/master-bank-offer/{bankId}",
        method: "delete",
    },

    // INTEREST RATE
    ADD_INTEREST_RATES: {
        url: "/api/v1/master-bank-rates",
        method: "post",
    },
    GET_INTEREST_RATES: {
        url: "/api/v1/master-bank-rates",
        method: "get",
    },
    GET_INTEREST_RATE_BY_ID: {
        url: "/api/v1/master-bank-rates/{interestRateId}",
        method: "get",
    },
    UPDATE_INTEREST_RATE: {
        url: "/api/v1/master-bank-rates/{interestRateId}",
        method: "put",
    },
    DELETE_INTEREST_RATE: {
        url: "/api/v1/master-bank-rates/{interestRateId}",
        method: "delete",
    },

    // PRODUCT TYPES
    ADD_PRODUCT_TYPE: {
        url: "/api/v1/master-product-type",
        method: "post",
    },
    GET_PRODUCT_TYPES: {
        url: "/api/v1/master-product-type",
        method: "get",
    },
    DELETE_PRODUCT_TYPE: {
        url: "/api/v1/master-product-type/{productType}",
        method: "delete",
    },
}